module.exports = __webpack_public_path__ + "media/images/icons/country_flags/do-a4fda0dd13778f9faf6699159d0ada51.svg";